import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconPlay = forwardRef<SVGSVGElement, IconProps>(function IconPlay(
  props,
  ref,
) {
  const { className, title, titleId, ...otherProps } = props
  const defaultClasses =
    "w-18 h-18 flex-shrink-0 fill-current transition-colors duration-150 ease-in focus:outline-none"
  const classes = mergeClasses(defaultClasses, className)

  return (
    <svg
      ref={ref}
      viewBox="0 0 72 71"
      focusable="false"
      aria-hidden="true"
      tabIndex={-1}
      className={classes}
      aria-labelledby={titleId}
      {...otherProps}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M58.1895 6.65625C59.9548 6.65625 61.6478 7.35753 62.8961 8.60582C64.1444 9.85411 64.8457 11.5472 64.8457 13.3125V57.6875C64.8457 59.4528 64.1444 61.1459 62.8961 62.3942C61.6478 63.6425 59.9548 64.3438 58.1895 64.3438H13.8145C12.0491 64.3438 10.3561 63.6425 9.10777 62.3942C7.85948 61.1459 7.1582 59.4528 7.1582 57.6875V13.3125C7.1582 11.5472 7.85948 9.85411 9.10777 8.60582C10.3561 7.35753 12.0491 6.65625 13.8145 6.65625H58.1895ZM58.1895 4.4375H13.8145C11.4607 4.4375 9.20327 5.37254 7.53888 7.03693C5.87449 8.70131 4.93945 10.9587 4.93945 13.3125V57.6875C4.93945 60.0413 5.87449 62.2987 7.53888 63.9631C9.20327 65.6275 11.4607 66.5625 13.8145 66.5625H58.1895C60.5433 66.5625 62.8006 65.6275 64.465 63.9631C66.1294 62.2987 67.0645 60.0413 67.0645 57.6875V13.3125C67.0645 10.9587 66.1294 8.70131 64.465 7.03693C62.8006 5.37254 60.5433 4.4375 58.1895 4.4375ZM27.127 51.3862H26.5945C26.4161 51.2944 26.2673 51.154 26.1653 50.9813C26.0632 50.8086 26.012 50.6105 26.0176 50.41V20.7231C26.012 20.5226 26.0632 20.3246 26.1653 20.1518C26.2673 19.9791 26.4161 19.8387 26.5945 19.7469C26.7664 19.636 26.9667 19.5771 27.1713 19.5771C27.3759 19.5771 27.5762 19.636 27.7482 19.7469L49.9357 34.5237C50.0824 34.6308 50.2018 34.7711 50.284 34.933C50.3663 35.0949 50.4092 35.274 50.4092 35.4556C50.4092 35.6373 50.3663 35.8163 50.284 35.9783C50.2018 36.1402 50.0824 36.2804 49.9357 36.3875L27.7482 51.1644C27.5714 51.3051 27.3529 51.3831 27.127 51.3862ZM28.2363 22.7644V48.2356L47.3176 35.5L28.2363 22.7644Z"
        fill="white"
      />
    </svg>
  )
})
